export const unitDist = 84;
export const unitDistIntervals = 30;
export const signatureWidth = 35;
export const lineDistance = 14;
export const barlineWidth: {[prop: string]: number} = {
    single: 12,
    ghost: 12,
    double: 18,
    final: 21,
    doubleRepeatEnd: 22,
    finalRepeatEnd: 25,
    doubleRepeatBoth: 22,
    finalRepeatBoth: 25,
    doubleRepeatStart: 12,
    doubleRepeatBothStart: 9,
    finalRepeatStart: 14,
    finalRepeatBothStart: 14,
};
export const paddingSide = 20;
export const paddingTop = 0;

export const stickOffset = 16;
export const stickHalfnoteOffset = 20;
export const stickBeamUpHeight = 6;
export const stickBeamDownHeight = 6;
export const stickSoloWidth = 10;
export const stickDotDimension = 4;
export const stickDotLeft = 24;
export const note16extra = 6;

export const noteheadOffset = 6;
export const stemOffset = 23;
export const beamUpHeight = 7;
export const beamDownHeight = 7;
export const dotDimension = 5;
export const dotLeft = 30;
export const soloWidth = 15;

export const clefWidth = 44;
export const hiddenClefWidth = 8;
export const doClefWidth = 38;
export const accidentalMargin = 6;

export const upperRowHeight = 46;
export const scoreBaseMargin = 6;
export const rhytPanelHeight = 75;
export const solfaPanelHeight = 105;

export const scoreStaffDistance = 130;
export const accidentalWidth = 14;
